export default () => ({
  imgArr: [],

  init() {
    // convert nodelist into a real array
    const images = this.$el.getElementsByTagName('img')
    // Make it an array and reverse it to match visual stacking order(so last image fades first)
    this.imgArr = Array.from(images).reverse()

    this.imgArr.forEach(img => {
      img.classList.add("transition-opacity", "duration-1000")
    });

    if (this.imgArr.length > 1) {
      setInterval(this.crossfade.bind(this), 4000);
    }
  },

  crossfade() {
    // fade images in and out
    this.imgArr[0].style.opacity = 0;
    this.imgArr[1].style.opacity = 1;

    this.imgArr.push(this.imgArr.shift()); // shift the array over
  }
})
